module.exports = __webpack_public_path__ + "static/img/01-友链3.cdc85a4.png";


//////////////////
// WEBPACK FOOTER
// ./public/pc/01-友链3.png
// module id = zi82
// module chunks = 14